
import { HttpClient } from '@angular/common/http';
import { Component, Inject, NgZone, OnInit, PLATFORM_ID, ViewEncapsulation } from '@angular/core';
// import 'rxjs/add/operator/map';
import { map } from 'rxjs/operators';
import * as xml2js from "xml2js";
// import * as JsonToXML from "js2xmlparser";
import {animate, state, style, transition, trigger} from '@angular/animations';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-fixed-fhathirty',
  templateUrl: './fixed-fhathirty.component.html',
  styleUrls: ['./fixed-fhathirty.component.css']
})
export class FixedFHAThirtyComponent implements OnInit {
  title = 'rates';
  
  totalAngularPackages: any;
  errorMessage: any;
  apiRoot: string;
  xml2js;
  string: string;
  xml: string;
  json: string;
  loanDetails: string;
  rate: string;
  price: string;
  originationFee: string;
  apr: string;
  prepayType: string;
  indexValue: string;
  margin: string;
  cap1: string;
  cap2: string;
  cap3: string;
  piti: string;
  downPayment: string;
  loanAmount: string;
  upfrontFee: string;
  monthlyPremium: string;
  results: any;
  isMenuOpen = false;

  clickedDivState = 'start';
  loanAmounts: any;
  propertyState: any;
  productList: any;
  propertyStates: any;
  productLists: any;
  isLoaded: boolean;
  loanProducts: any;
  lp1: any;
  lp2: any;
  lp3: any;
  appraisedValue: any;


  
  constructor(private http: HttpClient,  private activatedRoute: ActivatedRoute, @Inject(PLATFORM_ID) private platformId, private zone: NgZone){
    
    this.callAPI()
    const url = (window.location != window.parent.location)
    ? document.referrer
    : document.location.href;

  //   this.activatedRoute.queryParams.subscribe(params => {
     
  //     this.loanAmounts = params['loan_amount']
  //     this.propertyStates = params['propertyState']
  //     this.productLists = params['productList']
  //     this.loanProducts = params['loanProducts']
  //     this.lp1 = params['loanProduct1']
  //     this.lp2 = params['loanProduct2']
  //     this.lp3 = params['loanProduct3']
  //     this.appraisedValue = params['appraisedvalue']
      
  //     console.log(this.loanAmounts, this.propertyStates, this.productLists); 
  //     // Print the parameter to the console. 
  //     if(this.loanAmounts == undefined) {
  //       console.log('no params yet')
  //       this.isLoaded = false
  //     }
  //     else {
  //      this.isLoaded = true
  //       this.callAPI()
  //     }
  // });
  }
  ngOnInit() {
   
 
}
// https://thirdparty.mortech-inc.com/mpg/servlet/mpgThirdPartyServlet?request_id=1&customerId=15bbmc03&thirdPartyName=mutualmortgage&licenseKey={licenseKey}&emailAddress=mnyman@mutualmortgage.com&propertyState=IL&propertyZip=60148&appraisedvalue=350000&loan_amount=280000&fico=760&productList=4&firstTimeHomeBuyer=1
  async callAPI(){
    await this.apiRoot
  //  this.apiRoot = 'https://thirdparty.mortech-inc.com/mpg/servlet/mpgThirdPartyServlet?request_id=1&customerId=15bbmc03&thirdPartyName=mutualmortgage&licenseKey=GmMqeP9ek4uFMAeq&emailAddress=mnyman@mutualmortgage.com&'+'loan_amount='+ this.loanAmounts + '&' + 'appraisedvalue='+ this.appraisedValue + '&' + 'propertyState=' + this.propertyStates + '&' + 'productList='+ this.productLists

  this.apiRoot = 'https://thirdparty.mortech-inc.com/mpg/servlet/mpgThirdPartyServlet?request_id=1&customerId=15bbmc03&thirdPartyName=mutualmortgage&licenseKey=GmMqeP9ek4uFMAeq&emailAddress=mnyman@mutualmortgage.com&leadSource=10014&targetPrice=2&loan_amount=325000&productList=23&propertyState=CA&lockindays=15&fico=760&ltv=.80'

    // console.log(this.apiRoot)
       this.http.get(this.apiRoot, {responseType: 'text'}).subscribe({
         next: data => {
             this.totalAngularPackages = data;
             const p: xml2js.Parser = new xml2js.Parser();
             p.parseString(data, (err, result) => {
           this.results = result
          //    const json =JSON.stringify(result.mortech.results[0].quote[0].$.vendor_product_name, null, 6); 
          //    this.loanDetails =JSON.stringify(result.mortech.results[0].quote[0].quote_detail[0].$, null, 6); 
          //    this.rate = JSON.stringify(result.mortech.results[0].quote[0].quote_detail[0].$.rate, null, 6);
          //    this.apr = JSON.stringify(result.mortech.results[0].quote[0].quote_detail[0].$.apr, null, 6); 
          //    this.loanAmount = JSON.stringify(result.mortech.results[0].quote[0].quote_detail[0].$.loanAmount, null, 6);
    
   
          //  this.json = json
          //  console.log(this.results)
             }),
           
         this.xml = data
        
         
         },
         error: error => {
             this.errorMessage = error.message;
             console.error('There was an error!', error);
         }
     }) 
  }




loadRate(){
  this.callAPI()
}
  
  
}